import { useAuthContext } from "../context/AuthContext";
import { supabase } from "../lib/supabase";
import { clearAuthTokens } from "../lib/authUtils";
import { captureException, resetPostHog } from "../lib/posthog";

export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = async () => {
    try {
      // Sign out from Supabase
      const { error } = await supabase.auth.signOut();

      if (error) {
        console.error("Logout error:", error);
        captureException(error, { source: "useLogout", step: "signOut" });
        return { error };
      }

      // Clear local state
      dispatch({
        type: "LOGOUT",
        payload: null,
      });

      // Clear all auth tokens
      clearAuthTokens();

      resetPostHog();

      return { error: null };
    } catch (err) {
      console.error("Logout error:", err);
      captureException(err, { source: "useLogout", step: "outer" });
      return { error: err.message };
    }
  };

  return { logout };
};
